import axios from "axios";

// Frontend and /api share a host (preview, deploy domain and custom domains), so calls stay
// same-origin and the httpOnly session cookie is sent automatically. Local dev uses the env URL.
const isLocalDev = window.location.hostname === "localhost";
export const BACKEND_URL = isLocalDev ? process.env.REACT_APP_BACKEND_URL : window.location.origin;
export const API_BASE = `${BACKEND_URL}/api`;

// Session lives in an httpOnly cookie; the token is only kept in memory (never in web storage).
let memoryToken = null;
export const getToken = () => memoryToken;
export const setToken = (t) => { memoryToken = t || null; };

localStorage.removeItem("gridiron_token");

export const api = axios.create({
  baseURL: API_BASE,
});

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.message === "string") return detail.message;
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
